import { render, staticRenderFns } from "./Fourth.vue?vue&type=template&id=85288ac4&"
import script from "./Fourth.vue?vue&type=script&lang=ts&"
export * from "./Fourth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports